import { IDestroyOptions, Text } from "pixi.js";
import { MyWalletResourcePackage } from "../../resources/MyWalletResourcePackage";
import { MyWalletDataTextStyle, MyWalletDataView } from "./MyWalletDataView";
import { ButtonWithScaleAnimation } from "by/gamefactory/cityversetycoon/scenes/common/components/ButtonWithScaleAnimation";
import { StringFormatExtention } from "by/gamefactory/extensions/StringFormatExtention";
import { Event } from "event-system";

export class MyWalletAddressDataView extends MyWalletDataView {
    private static readonly DESCRIPTION_TEXT = 'WALLET\nADDRESS';

    public readonly onCopyAddress: Event<string>;

    private readonly myWalletAddress: Text;
    private readonly copyButton: ButtonWithScaleAnimation;
    private walletAddressValue: string;

    public constructor(myWalletResources: MyWalletResourcePackage, myWalletAddress: string) {
        super(myWalletResources, MyWalletAddressDataView.DESCRIPTION_TEXT);
        this.walletAddressValue = myWalletAddress;
        this.onCopyAddress = new Event();
        this.myWalletAddress = new Text(StringFormatExtention.walletAddressFormat(myWalletAddress), new MyWalletDataTextStyle());
        this.myWalletAddress.position.set(184, this.textFieldPlaceholder.height * 0.5 - this.myWalletAddress.height * 0.5);
        this.copyButton = new ButtonWithScaleAnimation(myWalletResources.assets_views_my_wallet_ui_copy_icon_png);
        this.copyButton.position.set(364, this.textFieldPlaceholder.height * 0.5 - this.copyButton.height * 0.5);
        this.copyButton.onUp.add(this.onCopyAddressButtonClickHandle, this);
        this.addChild(this.myWalletAddress, this.copyButton);
    }

    private onCopyAddressButtonClickHandle(): void {
        this.onCopyAddress.emit(this.walletAddressValue);
    }

    public set walletAddress(walletAddress: string) {
        this.myWalletAddress.text = StringFormatExtention.walletAddressFormat(walletAddress);
        this.walletAddressValue = walletAddress;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.copyButton.onUp.remove(this.onCopyAddressButtonClickHandle, this);
        super.destroy(options);
    }
}